import NavigatorUtil from '@/utils/navigator.util'

// 显示 吐司
export function UtilShowToast(
  {
    title = '系统开小差了，请稍后再试',
    icon = 'none' as 'success' | 'loading' | 'error' | 'none' | 'fail' | 'exception',
    duration = 2500,
    success,
    fail,
    complete,
  } = {} as any,
) {
  uni.showToast({
    icon,
    title,
    duration,
    success: () => {
      success && success()
    },
    fail: () => {
      fail && fail()
    },
    complete: () => {
      complete && complete()
    },
  })
}

// 隐藏吐司
export function UtilHideToast() {
  uni.hideToast()
}

// 显示loading
export function ShowLoading(option) {
  uni.showLoading(option)
}

// 关闭loading
export function HideLoading() {
  uni.hideLoading && uni.hideLoading()
}

// 设置系统剪贴板的内容
export function SetClipboardData(data) {
  uni.setClipboardData({
    data,
    success(res) {},
    fail(res) {},
  })
}

// 获取系统剪贴板内容。
export function GetClipboardData() {
  uni.getClipboardData({
    success: function (res) {},
  })
}

// 设置导航条
export function SetNavigationBarTitle({ title = '' } = {}) {
  uni.setNavigationBarTitle({
    title,
  })
}

// 图片预览
export function PreviewImage({ current = 0, indicator = 'number', urls } = {} as any) {
  uni.previewImage({
    current,
    indicator,
    urls,
  })
}

// 设置缓存
export function SetStorage(key, data, sync = true) {
  try {
    if (sync) {
      return uni.setStorageSync(key, data)
    } else {
      uni.setStorage({
        key,
        data,
      })
    }
  } catch (e) {}
}

// 获取缓存
export function GetStorage(key, sync = true) {
  try {
    if (sync) {
      return uni.getStorageSync(key)
    } else {
      let data = ''
      uni.getStorage({
        key,
        success: function (res) {
          data = res.data
        },
      })
      return data
    }
  } catch (e) {
    return false
  }
}

// 移除缓存
export function RemoveStorage(key, sync = true) {
  try {
    if (sync) {
      return uni.removeStorageSync(key)
    } else {
      uni.removeStorage({
        key,
      })
    }
  } catch (e) {
    return false
  }
}

// 清空缓存
export function ClearStorage(sync = true) {
  try {
    if (sync) {
      return uni.clearStorageSync()
    } else {
      uni.clearStorage()
    }
  } catch (e) {
    return false
  }
}

// 路由跳转
export function NavigationJump(key = 'navigateTo', options) {
  if (key === 'navigateTo') {
    uni.navigateTo(options)
  } else if (key === 'reLaunch') {
    uni.reLaunch(options)
  } else if (key === 'navigateBack') {
    uni.navigateBack(options)
  } else if (key === 'redirectTo') {
    uni.redirectTo(options)
  } else if (key === 'switchTab') {
    uni.switchTab(options)
  }
}
// 文件下载
export function WxDownloadFile({ url, filePath, successCallBack, errorCallBack }) {
  wx.downloadFile({
    url,
    filePath,
    success: function (result) {
      successCallBack && successCallBack(result)
    },
    fail: function (error) {
      errorCallBack && errorCallBack(error)
    },
  })
}

export function showModal(options) {
  uni.showModal(options)
}

// 打电话
export function TellPhone(mobile = '') {
  if (!mobile) return
  if (isAndroidWebView()) {
    NavigatorUtil.tel(mobile)
  } else {
    uni.makePhoneCall({
      phoneNumber: mobile,
      success() {},
      fail(error) {
        UtilShowToast({
          title: error.errMsg || '拨打电话失败!',
        })
      },
    })
  }
}
// 添加日程
export function AddCalendar(date, title, description) {
  if (isAndroidWebView()) {
    NavigatorUtil.addCalendar(date, title, description)
  }
}
// 跳转高德导航
export function openLocation(lon, lat, address) {
  if (isAndroidWebView()) {
    NavigatorUtil.gotoNavigate({
      lon,
      lat,
      address,
    })
  } else {
    uni.openLocation({
      latitude: lat,
      longitude: lon,
      name: address,
    })
  }
}
// 跳转需要跟app交互的横屏页面
export function gotoLandscapePage(url) {
  const screenWidth = uni.getSystemInfoSync().screenWidth
  if (isAndroidWebView() && screenWidth > 450) {
    NavigatorUtil.gotoEvaluateEdit({ url })
  } else {
    uni.navigateTo({
      url: '/' + url,
    })
  }
}
/**
 * @description                     检验是否为手机号  例如：13413131111 ===> true
 * @param phone {Number | String}   校验的数字 或者 字符串
 * @returns {boolean}
 */
export function isPhone(phone: any): boolean {
  return /^1[23456789]\d{9}$/.test(phone)
}

export function isAndroidWebView() {
  const ua = navigator.userAgent.toLowerCase()

  // 判断是否是 Android 设备
  const isAndroid = ua.includes('android')

  // 判断是否是 WebView (排除浏览器，如 Chrome)
  const isWebView = /wv|version\/[\d.]+ chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua)

  return isAndroid && isWebView
}

// 下载文件
export function downloadFile(url, filePath = '') {
  console.log('downloadFile', url, filePath)
  if (isAndroidWebView()) {
    NavigatorUtil.downloadFile(url)
  }
}
// 复制链接
export function copyLink(url) {
  if (!url) {
    UtilShowToast({
      title: '复制内容为空',
    })
    return
  }
  uni.setClipboardData({
    data: url,
    success() {
      UtilShowToast({
        title: '复制成功',
      })
    },
  })
}
